module.exports = __webpack_public_path__ + "img/hardwareOpen5.d367854c.png";